import React, {FC, useState} from 'react'
import AlertMessage from '../../../common/alert/AlertMsg'
import SharedData from '../../../common/SharedData'
import {enqueueRemoveSpecialBulk} from '../core/_requests'
import AllBranchesCheckbox from '../../../../components/AllBranchesCheckbox'
import Loader from '../../../common/Loader'
import {useNavigate} from 'react-router-dom'
import { useIntl } from 'react-intl'
type IProps = {
  bulkFile: any
  setBulkFile: React.Dispatch<any>
}
const SubmitButtonRow: FC<IProps> = ({
  bulkFile,
  setBulkFile,
}) => {
  const {formatMessage} = useIntl();
  const {currentUser, language} = SharedData()
  const navigate = useNavigate()

  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState(false)
  // Mart v2: the sheet's prices/discounts for every shop branch, not only the one in the header bar.
  const [allBranches, setAllBranches] = useState(false)
  const isFormHasError = () => {
    let hasError = false
    setBulkFile({
      ...bulkFile,
      error: false,
    })
    if (!bulkFile.value) {
      setBulkFile({
        ...bulkFile,
        error: true,
      })
      hasError = true
    }
    return hasError
  }
  const handleSubmit = async () => {
    if (!isFormHasError()) {
      setIsLoading(true)
      try {
        // Async: queued + tracked on the Bulk Jobs page (no in-request blob).
        const res: any = await enqueueRemoveSpecialBulk(
          currentUser?.token,
          {
            file: bulkFile.value,
          },
          language,
          allBranches,
        )
        if (res?.data?.job_id) {
          navigate('/products/bulk-jobs')
        } else {
          setError(true)
        }
      } catch (exp) {
        setError(true)
      }
      setIsLoading(false)
    } else {
    }
  }

  return (
    <>
      <AllBranchesCheckbox checked={allBranches} onChange={setAllBranches} disabled={isLoading} />
      <div className='adb-actionbar'>
        <div className='adb-actionbar-note'>
          <i className='fas fa-shield-halved' aria-hidden='true' />
          <span>{formatMessage({ id: "by_uploading_products_stnrd" })}</span>
        </div>
        <button onClick={handleSubmit} className='adb-actionbar-btn'>
          {formatMessage({ id: "upload" })}
        </button>
      </div>
      {isLoading && <Loader isFull={true} />}
      {error === true && (
        <AlertMessage
          title={formatMessage({ id: "something_wrong_title" })}
          message={formatMessage({ id: "something_wrong_desc" })}
          onClose={() => setError(false)}
        />
      )}
    </>
  )
}

export default SubmitButtonRow
